<!-- 提交按钮 -->
<template>
    <div v-if="componentsData.type == 20">
        <div class="bg-div" :style="bgStyle">
            <div :style="titleStyle" class="btn-div">{{ componentsData.content.title }}</div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        componentsData: {
            type: Object,
            default: {},
        },
    },
    computed: {
        titleStyle() {
            const content = this.componentsData.content;
            return {
                color: content.title_color,
                backgroundColor: content.button_submit_color,
                border: `1px solid ${content.border_color}`,
                padding: `${content.inner_spacing.top}px ${content.inner_spacing.left}px`,
                borderRadius: `${content.rounded_corner_setting.top}px ${content.rounded_corner_setting.top}px ${content.rounded_corner_setting.bottom}px ${content.rounded_corner_setting.bottom}px`,
            };
        },
        bgStyle() {
            const content = this.componentsData.content;
            const style = {};
            if (content.bg_color) {
                style.backgroundColor = content.bg_color;
            }
            const bgImg = content.bg_img || {};
            if (bgImg.picview && content.bg_value) {
                style.backgroundImage = `url(${bgImg.picview})`;
            }
            style.margin = `${content.outer_spacing.top}px ${content.outer_spacing.left}px`;
            return style;
        },
    },
};
</script>

<style scoped>
.bg-div {
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
}
.btn-div {
    text-align: center;
}
</style>
